export class SportDataGatewayStreamObserver {
    constructor(id, observer, onMessageHandler) {
        this.id = id;
        this.observer = observer;
        this.onMessageHandler = onMessageHandler;
    }
}
//# sourceMappingURL=SportDataGatewayStreamObserver.js.map